(function () {
  'use strict';

  var config = window.GastroFlow || {};
  var strings = Object.assign({
    add: 'Hinzufügen',
    quickAdd: 'Zum Warenkorb hinzufügen',
    adding: 'Wird hinzugefügt…',
    added: 'Hinzugefügt',
    soldOut: 'Ausverkauft',
    unavailable: 'Nicht verfügbar',
    cart: 'Warenkorb',
    emptyCart: 'Dein Warenkorb ist leer.',
    error: 'Das hat nicht geklappt. Bitte versuche es erneut.',
    remove: 'Entfernen',
    copied: 'Kopiert',
    noSearchResults: 'Keine passenden Gerichte gefunden.',
    searchError: 'Die Suche ist momentan nicht verfügbar.',
    productAdded: 'Produkt hinzugefügt',
    sauceLimit: 'Du kannst maximal {count} Saucen auswählen.'
  }, config.strings || {});

  var lastFocusedElement = null;
  var openingStatusTimer = null;
  var headerEventsBound = false;
  var searchDebounceTimer = null;
  var searchRequestId = 0;
  var copyToastTimer = null;
  var productToastTimer = null;
  var rootUrl = getRootUrl();
  var endpoints = {
    cart: buildRoute('cart.js'),
    add: buildRoute('cart/add.js'),
    change: buildRoute('cart/change.js'),
    predictiveSearch: buildRoute('search/suggest.json')
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTheme);
  } else {
    initTheme();
  }

  document.addEventListener('shopify:section:load', function () {
    bindMenuTabs();
    initHeaderBehavior();
    initOpeningStatus();
    initSauceSelectors(document);
    if (!isZapietEatsMode() || !(config.settings && config.settings.zapietEatsHideThemeCart)) {
      refreshCart();
    }
  });

  /**
   * Initializes all theme interactions.
   */
  function initTheme() {
    bindGlobalClicks();
    bindGlobalInputs();
    bindFormSubmissions();
    bindKeyboard();
    bindMenuTabs();
    initHeaderBehavior();
    initOpeningStatus();
    initSauceSelectors(document);
    if (!isZapietEatsMode() || !(config.settings && config.settings.zapietEatsHideThemeCart)) {
      refreshCart();
    }
  }

  /**
   * Returns Shopify's locale-aware root URL.
   */
  function getRootUrl() {
    var shopifyRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    var configuredRoot = config.routes && config.routes.root;
    var root = shopifyRoot || configuredRoot || '/';
    return root.charAt(root.length - 1) === '/' ? root : root + '/';
  }

  /**
   * Builds a locale-aware route.
   */
  function buildRoute(path) {
    return rootUrl + String(path || '').replace(/^\//, '');
  }

  /**
   * Returns whether the storefront should hand ordering over to Zapiet Eats.
   */
  function isZapietEatsMode() {
    return !!(config.settings && config.settings.zapietEatsMode);
  }

  /**
   * Opens the Zapiet Eats widget when available.
   */
  function openZapietEatsWidget(trigger) {
    closeNavigation(false);
    closeSearchModal();
    closeInfoDrawer(false);

    if (window.ZapietEats && typeof window.ZapietEats.openModal === 'function') {
      window.ZapietEats.openModal();
      return true;
    }

    showCopyToast('Zapiet Eats ist noch nicht geladen. Bitte versuche es gleich erneut.');
    return false;
  }

  /**
   * Binds delegated click interactions once.
   */
  function bindGlobalClicks() {
    if (document.documentElement.hasAttribute('data-theme-clicks-bound')) {
      return;
    }
    document.documentElement.setAttribute('data-theme-clicks-bound', 'true');

    document.addEventListener('click', function (event) {
      var navToggle = event.target.closest('[data-nav-toggle]');
      if (navToggle) {
        event.preventDefault();
        toggleNavigation(navToggle);
        return;
      }

      var searchOpen = event.target.closest('[data-search-open]');
      if (searchOpen) {
        event.preventDefault();
        closeNavigation(false);
        openSearchModal(searchOpen);
        return;
      }

      var searchClose = event.target.closest('[data-search-close]');
      if (searchClose) {
        event.preventDefault();
        closeSearchModal();
        return;
      }

      var searchClear = event.target.closest('[data-search-clear]');
      if (searchClear) {
        event.preventDefault();
        clearPredictiveSearch(searchClear.closest('[data-search-modal]'));
        return;
      }

      var infoOpen = event.target.closest('[data-info-open]');
      if (infoOpen) {
        event.preventDefault();
        closeNavigation(false);
        openInfoDrawer(infoOpen);
        return;
      }

      var infoClose = event.target.closest('[data-info-close]');
      if (infoClose) {
        if (infoClose.tagName === 'A') {
          closeInfoDrawer(false);
        } else {
          event.preventDefault();
          closeInfoDrawer(true);
        }
        return;
      }

      var filterOpen = event.target.closest('[data-filter-open]');
      if (filterOpen) {
        event.preventDefault();
        openFilterDrawer(filterOpen);
        return;
      }

      var filterClose = event.target.closest('[data-filter-close]');
      if (filterClose) {
        event.preventDefault();
        closeFilterDrawer();
        return;
      }

      var menuTab = event.target.closest('[data-menu-tab]');
      if (menuTab) {
        event.preventDefault();
        activateMenuTab(menuTab, false);
        return;
      }

      var zapietOpen = event.target.closest('[data-zapiet-eats-open]');
      if (zapietOpen) {
        event.preventDefault();
        openZapietEatsWidget(zapietOpen);
        return;
      }

      var copyCodeButton = event.target.closest('[data-copy-code]');
      if (copyCodeButton) {
        event.preventDefault();
        copyDiscountCode(copyCodeButton);
        return;
      }

      var quickOrderTrigger = event.target.closest('[data-quick-order-trigger]');
      if (quickOrderTrigger) {
        if (openQuickOrder(quickOrderTrigger)) {
          event.preventDefault();
        }
        return;
      }

      var quickOption = event.target.closest('[data-quick-option-button]');
      if (quickOption) {
        event.preventDefault();
        selectQuickOption(quickOption);
        return;
      }

      var quickOrderClose = event.target.closest('[data-quick-order-close]');
      if (quickOrderClose) {
        event.preventDefault();
        closeQuickOrder(quickOrderClose.closest('[data-quick-order]') || getActiveQuickOrder());
        return;
      }





      var cartOpen = event.target.closest('[data-cart-open]');
      if (cartOpen) {
        event.preventDefault();
        closeNavigation(false);
        lastFocusedElement = cartOpen;
        refreshCart().then(openCartDrawer);
        return;
      }

      var cartClose = event.target.closest('[data-cart-close]');
      if (cartClose) {
        event.preventDefault();
        closeCartDrawer();
        return;
      }

      var lineChange = event.target.closest('[data-line-change]');
      if (lineChange) {
        event.preventDefault();
        updateCartLine(lineChange.getAttribute('data-key'), parseInt(lineChange.getAttribute('data-quantity'), 10));
        return;
      }

      var lineRemove = event.target.closest('[data-line-remove]');
      if (lineRemove) {
        event.preventDefault();
        updateCartLine(lineRemove.getAttribute('data-key'), 0);
        return;
      }

      var quantityButton = event.target.closest('[data-quantity-plus], [data-quantity-minus]');
      if (quantityButton) {
        event.preventDefault();
        updateFormQuantity(quantityButton);
        return;
      }

      if (event.target.closest('[data-nav] a, [data-mobile-nav-panel] a')) {
        closeNavigation();
      }
    });
  }

  /**
   * Binds delegated input and change interactions once.
   */
  function bindGlobalInputs() {
    if (document.documentElement.hasAttribute('data-theme-inputs-bound')) {
      return;
    }
    document.documentElement.setAttribute('data-theme-inputs-bound', 'true');

    document.addEventListener('input', function (event) {
      var searchInput = event.target.closest('[data-search-input]');
      if (searchInput) {
        schedulePredictiveSearch(searchInput);
        return;
      }

      var quickQuantity = event.target.closest('[data-quick-order] input[name="quantity"]');
      if (quickQuantity) {
        normalizeQuantityInput(quickQuantity);
        updateQuickOrderTotal(quickQuantity.closest('[data-quick-order]'));
      }
    });

    document.addEventListener('change', function (event) {
      var sauceOption = event.target.closest('[data-sauce-option]');
      if (sauceOption) {
        updateSauceSelector(sauceOption.closest('[data-sauce-selector]'), sauceOption, true);
        return;
      }

      var autoSubmit = event.target.closest('[data-auto-submit]');
      if (autoSubmit && autoSubmit.form) {
        autoSubmit.form.submit();
        return;
      }

      var quickSelect = event.target.closest('[data-quick-order-variant-select]');
      if (quickSelect) {
        updateQuickOrderFromSelect(quickSelect);
        return;
      }

      var quickQuantity = event.target.closest('[data-quick-order] input[name="quantity"]');
      if (quickQuantity) {
        normalizeQuantityInput(quickQuantity);
        updateQuickOrderTotal(quickQuantity.closest('[data-quick-order]'));
        return;
      }

      var variantSelect = event.target.closest('[data-variant-select]');
      if (variantSelect) {
        updateVariantState(variantSelect);
      }
    });
  }

  /**
   * Binds Ajax add-to-cart forms once.
   */
  function bindFormSubmissions() {
    if (document.documentElement.hasAttribute('data-theme-forms-bound')) {
      return;
    }
    document.documentElement.setAttribute('data-theme-forms-bound', 'true');

    document.addEventListener('submit', function (event) {
      var addForm = event.target.closest('form[action*="/cart/add"], .js-add-to-cart-form');
      if (isZapietEatsMode() && addForm && !addForm.hasAttribute('data-zapiet-allow-cart')) {
        event.preventDefault();
        openZapietEatsWidget(addForm);
        return;
      }

      var form = event.target.closest('.js-add-to-cart-form');
      if (!form || !window.fetch || !window.FormData) {
        return;
      }

      event.preventDefault();
      addToCart(form);
    });
  }

  /**
   * Binds keyboard behavior for tabs and overlays once.
   */
  function bindKeyboard() {
    if (document.documentElement.hasAttribute('data-theme-keyboard-bound')) {
      return;
    }
    document.documentElement.setAttribute('data-theme-keyboard-bound', 'true');

    document.addEventListener('keydown', function (event) {
      var currentMenuTab = event.target.closest('[data-menu-tab]');
      if (currentMenuTab) {
        navigateMenuTabs(event, currentMenuTab);
      }

      if (event.key === 'Escape') {
        closeQuickOrder(getActiveQuickOrder());
        closeCartDrawer();
        closeSearchModal();
        closeInfoDrawer(true);
        closeFilterDrawer();
        closeNavigation();
        return;
      }

      if (event.key !== 'Tab') {
        return;
      }

      var activeOverlay = getActiveQuickOrder() ||
        document.querySelector('[data-search-modal]:not([hidden])') ||
        document.querySelector('[data-info-drawer]:not([hidden])') ||
        document.querySelector('[data-filter-drawer]:not([hidden])') ||
        document.querySelector('[data-cart-drawer]:not([hidden])');

      if (activeOverlay) {
        trapFocus(event, activeOverlay);
        return;
      }

    });
  }

  /**
   * Initializes each restaurant menu as an accessible tab interface.
   */
  function bindMenuTabs() {
    document.querySelectorAll('[data-menu-tabs]').forEach(function (tabList) {
      var tabs = Array.prototype.slice.call(tabList.querySelectorAll('[data-menu-tab]'));
      if (!tabs.length) {
        return;
      }

      var selectedTab = tabs.find(function (tab) {
        return tab.getAttribute('aria-selected') === 'true';
      }) || tabs[0];

      activateMenuTab(selectedTab, false);
    });
  }

  /**
   * Activates a menu category tab and its matching panel.
   */
  function activateMenuTab(tab, moveFocus) {
    if (!tab) {
      return;
    }

    var tabList = tab.closest('[data-menu-tabs]');
    var menuRoot = tab.closest('[data-menu-root]');
    var targetId = tab.getAttribute('aria-controls');
    if (!tabList || !menuRoot || !targetId) {
      return;
    }

    tabList.querySelectorAll('[data-menu-tab]').forEach(function (item) {
      var isActive = item === tab;
      item.classList.toggle('is-active', isActive);
      item.setAttribute('aria-selected', isActive ? 'true' : 'false');
      item.setAttribute('tabindex', isActive ? '0' : '-1');
    });

    menuRoot.querySelectorAll('[data-menu-panel]').forEach(function (panel) {
      var isActive = panel.id === targetId;
      panel.hidden = !isActive;
      panel.classList.toggle('is-active', isActive);
    });

    if (moveFocus) {
      tab.focus();
    }
  }

  /**
   * Moves focus between menu tabs with arrow keys.
   */
  function navigateMenuTabs(event, currentTab) {
    var tabList = currentTab.closest('[data-menu-tabs]');
    if (!tabList) {
      return;
    }

    var tabs = Array.prototype.slice.call(tabList.querySelectorAll('[data-menu-tab]'));
    var currentIndex = tabs.indexOf(currentTab);
    var nextIndex = currentIndex;

    if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
      nextIndex = (currentIndex + 1) % tabs.length;
    } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
      nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
    } else if (event.key === 'Home') {
      nextIndex = 0;
    } else if (event.key === 'End') {
      nextIndex = tabs.length - 1;
    } else {
      return;
    }

    event.preventDefault();
    activateMenuTab(tabs[nextIndex], true);
  }

  /**
   * Returns whether the current viewport uses the mobile header navigation.
   */
  function isMobileNavigationViewport() {
    return window.matchMedia('(max-width: 989px)').matches;
  }

  /**
   * Returns the mobile navigation panel controlled by a toggle.
   */
  function getControlledNavigation(toggle) {
    var navId = toggle ? toggle.getAttribute('aria-controls') : '';
    if (navId) {
      var controlled = document.getElementById(navId);
      if (controlled) {
        return controlled;
      }
    }

    var header = toggle ? toggle.closest('[data-site-header]') : null;
    if (header) {
      return header.querySelector('[data-mobile-nav-panel]') || header.querySelector('[data-nav]');
    }

    return document.querySelector('[data-mobile-nav-panel]') || document.querySelector('[data-nav]');
  }

  /**
   * Prepares the mobile navigation panel inside the active sticky header.
   * The header group is fixed while the menu is open so the panel always
   * appears below the visible navbar, independent of the page scroll position.
   */
  function prepareMobileNavigationPanel(nav) {
    if (!nav || !isMobileNavigationViewport()) {
      return;
    }

    nav.style.removeProperty('--mobile-nav-top');
    nav.style.removeProperty('--mobile-nav-left');
    nav.style.removeProperty('--mobile-nav-width');
  }

  /**
   * Opens the mobile header navigation below the visible sticky navbar.
   */
  function openMobileNavigation(nav, toggle) {
    if (!nav) {
      return;
    }

    closeNavigation(false);
    lastFocusedElement = toggle || document.activeElement;
    prepareMobileNavigationPanel(nav);

    var header = (toggle && toggle.closest('[data-site-header]')) || nav.closest('[data-site-header]');
    if (header) {
      header.classList.add('is-mobile-menu-open');
      var wrapper = header.closest('.shopify-section-group-header-group');
      if (wrapper) {
        wrapper.classList.add('is-mobile-menu-open');
      }
    }

    document.body.classList.add('nav-open');
    nav.hidden = false;
    nav.setAttribute('aria-hidden', 'false');

    if (toggle) {
      toggle.setAttribute('aria-expanded', 'true');
    }

    window.requestAnimationFrame(function () {
      nav.classList.add('is-open');
    });
  }

  /**
   * Closes mobile header navigation panels.
   */
  function closeMobileNavigationPanel() {
    document.querySelectorAll('[data-mobile-nav-panel]').forEach(function (panel) {
      if (panel.hidden && !panel.classList.contains('is-open')) {
        return;
      }

      panel.classList.remove('is-open');
      panel.setAttribute('aria-hidden', 'true');

      var header = panel.closest('[data-site-header]');
      if (header) {
        header.classList.remove('is-mobile-menu-open');
        var wrapper = header.closest('.shopify-section-group-header-group');
        if (wrapper) {
          wrapper.classList.remove('is-mobile-menu-open');
        }
      }

      window.setTimeout(function () {
        if (!panel.classList.contains('is-open')) {
          panel.hidden = true;
          panel.style.removeProperty('--mobile-nav-top');
          panel.style.removeProperty('--mobile-nav-left');
          panel.style.removeProperty('--mobile-nav-width');
        }
      }, prefersReducedMotion() ? 0 : 220);
    });
  }

  /**
   * Keeps the open mobile navigation in the header flow. No viewport math is
   * needed because the full header group is fixed while nav-open is active.
   */
  function updateOpenMobileNavigationPosition() {
    if (!isMobileNavigationViewport()) {
      closeNavigation(false);
    }
  }

  /**
   * Toggles the mobile/desktop navigation.
   */
  function toggleNavigation(toggle) {
    var nav = getControlledNavigation(toggle);
    if (!nav) {
      return;
    }

    if (isMobileNavigationViewport()) {
      var isOpen = nav.classList.contains('is-open') && !nav.hidden;
      if (isOpen) {
        closeNavigation(true);
      } else {
        openMobileNavigation(nav, toggle);
      }
      return;
    }

    var desktopNavId = nav.getAttribute('data-nav') != null ? nav.id : '';
    var desktopNav = desktopNavId ? nav : document.querySelector('[data-nav]');
    if (!desktopNav) {
      return;
    }

    var desktopIsOpen = desktopNav.classList.toggle('is-open');
    if (toggle) {
      toggle.setAttribute('aria-expanded', desktopIsOpen ? 'true' : 'false');
    }
    document.body.classList.toggle('nav-open', desktopIsOpen);
  }

  /**
   * Closes the mobile/desktop navigation.
   */
  function closeNavigation(restoreFocus) {
    document.querySelectorAll('[data-nav].is-open').forEach(function (nav) {
      nav.classList.remove('is-open');
    });
    closeMobileNavigationPanel();
    document.querySelectorAll('[data-nav-toggle]').forEach(function (toggle) {
      toggle.setAttribute('aria-expanded', 'false');
    });
    document.body.classList.remove('nav-open');

    if (restoreFocus && lastFocusedElement && typeof lastFocusedElement.focus === 'function' && document.contains(lastFocusedElement)) {
      lastFocusedElement.focus({ preventScroll: true });
    }
  }

  /**
   * Initializes sticky and transparent header behavior.
   */
  function initHeaderBehavior() {
    initializeHeaderSectionWrapper();
    updateHeaderMetrics();
    updateHeaderState();

    if (headerEventsBound) {
      return;
    }

    headerEventsBound = true;
    window.addEventListener('scroll', updateHeaderState, { passive: true });
    window.addEventListener('scroll', updateOpenMobileNavigationPosition, { passive: true });
    window.addEventListener('resize', updateHeaderMetrics, { passive: true });
    window.addEventListener('resize', updateOpenMobileNavigationPosition, { passive: true });
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', updateOpenMobileNavigationPosition, { passive: true });
      window.visualViewport.addEventListener('scroll', updateOpenMobileNavigationPosition, { passive: true });
    }
  }

  /**
   * Mirrors header modes onto the generated Shopify section wrapper.
   */
  function initializeHeaderSectionWrapper() {
    var transparentHeader = false;
    document.querySelectorAll('[data-site-header]').forEach(function (header) {
      var wrapper = header.closest('.shopify-section');
      if (!wrapper) {
        return;
      }

      wrapper.classList.add('gastroflow-header-section');
      wrapper.classList.toggle('gastroflow-header-wrapper--sticky', header.classList.contains('site-header--sticky'));
      wrapper.classList.toggle('gastroflow-header-wrapper--transparent', header.classList.contains('site-header--transparent'));
      wrapper.classList.toggle('gastroflow-header-wrapper--standard', header.classList.contains('site-header--standard'));
      transparentHeader = transparentHeader || header.classList.contains('site-header--transparent');
    });
    document.body.classList.toggle('has-transparent-site-header', transparentHeader);
  }

  /**
   * Updates CSS variables used by the header and hero layout.
   */
  function updateHeaderMetrics() {
    var topbar = document.querySelector('.announcement-bar');
    var header = document.querySelector('[data-site-header]');
    var topbarHeight = topbar ? Math.round(topbar.getBoundingClientRect().height) : 0;
    var headerHeight = header ? Math.round(header.getBoundingClientRect().height) : 0;

    document.documentElement.style.setProperty('--announcement-height', topbarHeight + 'px');
    if (headerHeight > 0) {
      document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
    }
  }

  /**
   * Applies the scrolled state to sticky headers.
   */
  function updateHeaderState() {
    var isScrolled = window.scrollY > 18;
    document.querySelectorAll('[data-site-header]').forEach(function (header) {
      var wrapper = header.closest('.shopify-section');
      header.classList.toggle('is-scrolled', isScrolled);
      if (wrapper) {
        wrapper.classList.toggle('is-header-scrolled', isScrolled);
      }
    });
    window.requestAnimationFrame(updateHeaderMetrics);
  }

  /**
   * Opens the search dialog.
   */
  function openSearchModal(trigger) {
    var modal = document.querySelector('[data-search-modal]');
    if (!modal) {
      return;
    }

    lastFocusedElement = trigger || document.activeElement;
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('search-modal-open');

    window.requestAnimationFrame(function () {
      modal.classList.add('is-open');
      window.setTimeout(function () {
        var input = modal.querySelector('[data-search-input]');
        if (input) {
          input.focus({ preventScroll: true });
        }
      }, 120);
    });
  }

  /**
   * Closes the search dialog.
   */
  function closeSearchModal() {
    var modal = document.querySelector('[data-search-modal]:not([hidden])');
    if (!modal) {
      return;
    }

    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    window.setTimeout(function () {
      modal.hidden = true;
      document.body.classList.remove('search-modal-open');
      restoreLastFocus();
    }, 260);
  }

  /**
   * Clears the predictive-search field and results.
   */
  function clearPredictiveSearch(modal) {
    if (!modal) {
      return;
    }

    var input = modal.querySelector('[data-search-input]');
    var clearButton = modal.querySelector('[data-search-clear]');
    var predictive = modal.querySelector('[data-predictive-search]');
    var results = modal.querySelector('[data-search-results]');
    var status = modal.querySelector('[data-search-status]');

    if (input) {
      input.value = '';
      input.focus({ preventScroll: true });
    }
    if (clearButton) {
      clearButton.hidden = true;
    }
    if (predictive) {
      predictive.hidden = true;
      predictive.classList.remove('is-loading');
    }
    if (results) {
      results.innerHTML = '';
    }
    if (status) {
      status.textContent = '';
    }
  }

  /**
   * Debounces predictive product search requests.
   */
  function schedulePredictiveSearch(input) {
    var modal = input.closest('[data-search-modal]');
    var query = String(input.value || '').trim();
    var clearButton = modal ? modal.querySelector('[data-search-clear]') : null;

    if (clearButton) {
      clearButton.hidden = query.length === 0;
    }

    window.clearTimeout(searchDebounceTimer);
    if (query.length < 2) {
      clearPredictiveResults(modal);
      return;
    }

    searchDebounceTimer = window.setTimeout(function () {
      fetchPredictiveSearch(modal, query);
    }, 220);
  }

  /**
   * Fetches locale-aware predictive-search product results.
   */
  async function fetchPredictiveSearch(modal, query) {
    if (!modal || !window.fetch) {
      return;
    }

    var predictive = modal.querySelector('[data-predictive-search]');
    var results = modal.querySelector('[data-search-results]');
    var status = modal.querySelector('[data-search-status]');
    var requestId = ++searchRequestId;
    var url = endpoints.predictiveSearch + '?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';

    if (predictive) {
      predictive.hidden = false;
      predictive.classList.add('is-loading');
    }
    if (status) {
      status.textContent = 'Suche läuft …';
    }

    try {
      var response = await fetch(url, { headers: { Accept: 'application/json' } });
      if (!response.ok) {
        throw new Error(strings.searchError);
      }

      var payload = await response.json();
      if (requestId !== searchRequestId) {
        return;
      }

      var products = payload && payload.resources && payload.resources.results && payload.resources.results.products;
      products = Array.isArray(products) ? products : [];
      renderPredictiveSearch(results, products, modal.getAttribute('data-show-product-images') === 'true');
      if (status) {
        status.textContent = products.length ? products.length + ' Treffer' : strings.noSearchResults;
      }
    } catch (error) {
      if (requestId !== searchRequestId) {
        return;
      }
      if (results) {
        results.innerHTML = '<p class="predictive-search__empty">' + escapeHTML(strings.searchError) + '</p>';
      }
      if (status) {
        status.textContent = strings.searchError;
      }
    } finally {
      if (predictive && requestId === searchRequestId) {
        predictive.classList.remove('is-loading');
      }
    }
  }

  /**
   * Renders predictive-search products.
   */
  function renderPredictiveSearch(container, products, showImages) {
    if (!container) {
      return;
    }

    if (!products.length) {
      container.innerHTML = '<p class="predictive-search__empty">' + escapeHTML(strings.noSearchResults) + '</p>';
      return;
    }

    var searchModal = container.closest('[data-search-modal]');
    var showProductImages = !searchModal || searchModal.getAttribute('data-show-product-images') === 'true';

    container.innerHTML = products.map(function (product) {
      var image = showProductImages ? getPredictiveImage(product) : '';
      var imageMarkup = showProductImages
        ? (image
          ? '<span class="predictive-search__media"><img src="' + escapeAttribute(image) + '" alt="" loading="lazy" width="96" height="96"></span>'
          : '<span class="predictive-search__media predictive-search__media--empty" aria-hidden="true"></span>')
        : '';
      var price = formatPredictivePrice(product.price);
      return [
        '<a class="predictive-search__item' + (showProductImages ? '' : ' predictive-search__item--no-media') + '" href="' + escapeAttribute(product.url || '#') + '">',
          imageMarkup,
          '<span class="predictive-search__copy"><strong>' + escapeHTML(product.title || '') + '</strong>',
          price ? '<small>' + escapeHTML(price) + '</small>' : '',
          '</span><span class="predictive-search__arrow" aria-hidden="true">→</span>',
        '</a>'
      ].join('');
    }).join('');
  }

  /**
   * Returns a predictive-search image URL across API response variants.
   */
  function getPredictiveImage(product) {
    if (!product) {
      return '';
    }
    if (product.featured_image && product.featured_image.url) {
      return product.featured_image.url;
    }
    if (product.featured_image && typeof product.featured_image === 'string') {
      return product.featured_image;
    }
    if (product.image) {
      return typeof product.image === 'string' ? product.image : product.image.url || '';
    }
    return '';
  }

  /**
   * Normalizes predictive-search price output.
   */
  function formatPredictivePrice(value) {
    if (value == null || value === '') {
      return '';
    }
    if (typeof value === 'number') {
      return formatMoney(value);
    }
    var text = String(value).trim();
    if (/^[0-9]+([.,][0-9]+)?$/.test(text)) {
      return formatMoney(Math.round(parseFloat(text.replace(',', '.')) * 100));
    }
    return text;
  }

  /**
   * Clears predictive-search output without changing the input.
   */
  function clearPredictiveResults(modal) {
    if (!modal) {
      return;
    }
    var predictive = modal.querySelector('[data-predictive-search]');
    var results = modal.querySelector('[data-search-results]');
    var status = modal.querySelector('[data-search-status]');
    if (predictive) {
      predictive.hidden = true;
      predictive.classList.remove('is-loading');
    }
    if (results) {
      results.innerHTML = '';
    }
    if (status) {
      status.textContent = '';
    }
  }

  /**
   * Opens the mobile opening-hours and contact drawer.
   */
  function openInfoDrawer(trigger) {
    var drawer = document.querySelector('[data-info-drawer]');
    if (!drawer) {
      return;
    }

    lastFocusedElement = trigger || document.activeElement;
    drawer.hidden = false;
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('info-drawer-open');

    window.requestAnimationFrame(function () {
      drawer.classList.add('is-open');
      window.setTimeout(function () {
        var closeButton = drawer.querySelector('[data-info-close]');
        if (closeButton) {
          closeButton.focus({ preventScroll: true });
        }
      }, 120);
    });
  }

  /**
   * Closes the mobile opening-hours and contact drawer.
   */
  function closeInfoDrawer(restoreFocus) {
    var drawer = document.querySelector('[data-info-drawer]:not([hidden])');
    if (!drawer) {
      return;
    }

    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    window.setTimeout(function () {
      drawer.hidden = true;
      document.body.classList.remove('info-drawer-open');
      if (restoreFocus !== false) {
        restoreLastFocus();
      }
    }, 280);
  }

  /**
   * Opens a collection filter drawer.
   */
  function openFilterDrawer(trigger) {
    var drawerId = trigger ? trigger.getAttribute('aria-controls') : '';
    var drawer = drawerId ? document.getElementById(drawerId) : document.querySelector('[data-filter-drawer]');
    if (!drawer) {
      return;
    }

    lastFocusedElement = trigger || document.activeElement;
    drawer.hidden = false;
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('filter-drawer-open');

    window.requestAnimationFrame(function () {
      var closeButton = drawer.querySelector('[data-filter-close]');
      if (closeButton) {
        closeButton.focus({ preventScroll: true });
      }
    });
  }

  /**
   * Closes the active collection filter drawer.
   */
  function closeFilterDrawer() {
    var drawer = document.querySelector('[data-filter-drawer]:not([hidden])');
    if (!drawer) {
      return;
    }

    drawer.hidden = true;
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('filter-drawer-open');
    restoreLastFocus();
  }

  /**
   * Restores focus after closing an overlay.
   */
  function restoreLastFocus() {
    if (lastFocusedElement && typeof lastFocusedElement.focus === 'function' && document.contains(lastFocusedElement)) {
      lastFocusedElement.focus({ preventScroll: true });
    }
  }

  /**
   * Initializes the automatic restaurant opening status.
   */
  function initOpeningStatus() {
    if (openingStatusTimer) {
      window.clearInterval(openingStatusTimer);
      openingStatusTimer = null;
    }

    updateOpeningStatus();
    if (document.querySelector('[data-opening-hours-config]')) {
      openingStatusTimer = window.setInterval(updateOpeningStatus, 60000);
    }
  }

  /**
   * Updates every opening-status component from the global schedule.
   */
  function updateOpeningStatus() {
    var configNode = document.querySelector('[data-opening-hours-config]');
    if (!configNode) {
      return;
    }

    var schedule;
    try {
      schedule = JSON.parse(configNode.textContent || '{}');
    } catch (error) {
      return;
    }

    var status = getOpeningStatus(schedule, new Date());
    document.querySelectorAll('[data-opening-status]').forEach(function (target) {
      var fullTextNodes = target.querySelectorAll('[data-opening-status-text]');
      var shortTextNodes = target.querySelectorAll('[data-opening-status-short]');
      var detailTextNodes = target.querySelectorAll('[data-opening-status-detail]');
      fullTextNodes.forEach(function (node) { node.textContent = status.text; });
      shortTextNodes.forEach(function (node) { node.textContent = status.shortText; });
      detailTextNodes.forEach(function (node) { node.textContent = status.detailText || status.text; });
      target.classList.toggle('is-open', status.isOpen);
      target.classList.toggle('is-closed', !status.isOpen);
      target.setAttribute('data-state', status.isOpen ? 'open' : 'closed');
    });
  }

  /**
   * Calculates whether the restaurant is open and the next relevant time.
   */
  function getOpeningStatus(schedule, now) {
    var timezone = schedule.timezone || 'Europe/Berlin';
    var parts = getZonedTimeParts(now, timezone);
    var days = Array.isArray(schedule.days) ? schedule.days : [];
    var openText = schedule.openText || 'Geöffnet';
    var closedText = schedule.closedText || 'Geschlossen';
    var today = days[parts.dayIndex] || {};
    var previous = days[(parts.dayIndex + 6) % 7] || {};
    var currentMinutes = parts.hour * 60 + parts.minute;
    var todayOpen = parseTimeToMinutes(today.open);
    var todayClose = parseTimeToMinutes(today.close);
    var previousOpen = parseTimeToMinutes(previous.open);
    var previousClose = parseTimeToMinutes(previous.close);

    if (previous.enabled && previousOpen != null && previousClose != null && previousClose <= previousOpen && currentMinutes < previousClose) {
      return { isOpen: true, shortText: openText, text: openText + ' · bis ' + formatTime(previous.close), detailText: 'Bis ' + formatTime(previous.close) };
    }

    if (today.enabled && todayOpen != null && todayClose != null) {
      var isOvernight = todayClose <= todayOpen;
      var isOpen = isOvernight ? currentMinutes >= todayOpen : currentMinutes >= todayOpen && currentMinutes < todayClose;
      if (isOpen) {
        return { isOpen: true, shortText: openText, text: openText + ' · bis ' + formatTime(today.close), detailText: 'Bis ' + formatTime(today.close) };
      }
      if (currentMinutes < todayOpen) {
        return { isOpen: false, shortText: closedText, text: closedText + ' · öffnet um ' + formatTime(today.open), detailText: 'Öffnet um ' + formatTime(today.open) };
      }
    }

    for (var offset = 1; offset <= 7; offset += 1) {
      var day = days[(parts.dayIndex + offset) % 7] || {};
      if (day.enabled && parseTimeToMinutes(day.open) != null) {
        var prefix = offset === 1 ? 'morgen' : String(day.label || '').toLowerCase();
        return { isOpen: false, shortText: closedText, text: closedText + ' · öffnet ' + prefix + ' ' + formatTime(day.open), detailText: 'Öffnet ' + prefix + ' ' + formatTime(day.open) };
      }
    }

    return { isOpen: false, shortText: closedText, text: closedText, detailText: closedText };
  }

  /**
   * Returns local time parts for an IANA timezone.
   */
  function getZonedTimeParts(date, timezone) {
    try {
      var formatter = new Intl.DateTimeFormat('en-US', {
        timeZone: timezone,
        weekday: 'short',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
      });
      var values = {};
      formatter.formatToParts(date).forEach(function (part) {
        if (part.type !== 'literal') {
          values[part.type] = part.value;
        }
      });
      var weekdays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
      return {
        dayIndex: Math.max(0, weekdays.indexOf(values.weekday)),
        hour: parseInt(values.hour, 10) % 24,
        minute: parseInt(values.minute, 10)
      };
    } catch (error) {
      return { dayIndex: date.getDay(), hour: date.getHours(), minute: date.getMinutes() };
    }
  }

  /**
   * Converts HH:MM into minutes after midnight.
   */
  function parseTimeToMinutes(value) {
    if (!value || !/^\d{1,2}:\d{2}$/.test(String(value))) {
      return null;
    }
    var parts = String(value).split(':');
    var hours = parseInt(parts[0], 10);
    var minutes = parseInt(parts[1], 10);
    if (!Number.isFinite(hours) || !Number.isFinite(minutes)) {
      return null;
    }
    return hours * 60 + minutes;
  }

  /**
   * Formats HH:MM as a German time label.
   */
  function formatTime(value) {
    return value ? String(value).replace(/^0/, '') + ' Uhr' : '';
  }

  /**
   * Opens and populates the quick-order dialog.
   */
  function openQuickOrder(trigger) {
    var card = trigger.closest('[data-quick-order-card]');
    var product = readProductJSON(card);
    if (!card || !product || !product.variants || !product.variants.length) {
      return false;
    }

    var menuSection = trigger.closest('[data-menu-root]');
    var modal = menuSection
      ? menuSection.querySelector('[data-quick-order]')
      : document.querySelector('[data-global-quick-order]') || document.querySelector('[data-quick-order]');

    if (!modal) {
      return false;
    }

    lastFocusedElement = trigger;
    prepareQuickOrder(modal, product, trigger.getAttribute('data-allow-note') !== 'false');
    modal.hidden = false;
    modal.classList.remove('is-closing', 'is-visible');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('quick-order-open');
    modal.getBoundingClientRect();

    window.requestAnimationFrame(function () {
      modal.classList.add('is-visible');
      var focusTarget = modal.querySelector('[data-quick-order-close]') || modal.querySelector('[data-quick-option-button]') || modal.querySelector('[data-add-button]');
      if (focusTarget) {
        focusTarget.focus({ preventScroll: true });
      }
    });

    return true;
  }

  /**
   * Parses product data embedded in a product card.
   */
  function readProductJSON(card) {
    if (!card) {
      return null;
    }
    var script = card.querySelector('[data-product-json]');
    if (!script) {
      return null;
    }
    try {
      return JSON.parse(script.textContent || '{}');
    } catch (error) {
      return null;
    }
  }

  /**
   * Populates a quick-order dialog and stores its product state.
   */
  function prepareQuickOrder(modal, product, allowNote) {
    var firstAvailable = product.variants.filter(function (variant) { return variant.available; })[0] || product.variants[0];
    var selectedOptions = getVariantOptions(firstAvailable);
    var form = modal.querySelector('[data-quick-order-form]');
    var noteWrap = modal.querySelector('[data-quick-order-note-wrap]');
    var noteInput = noteWrap ? noteWrap.querySelector('input, textarea') : null;
    var quantityInput = form ? form.querySelector('input[name="quantity"]') : null;
    var media = modal.querySelector('[data-quick-order-media]');
    var image = modal.querySelector('[data-quick-order-image]');

    modal._quickOrderState = {
      product: product,
      selectedOptions: selectedOptions,
      selectedVariant: firstAvailable
    };

    setText(modal.querySelector('[data-quick-order-title]'), product.title || '');
    setText(modal.querySelector('[data-quick-order-description]'), stripHTML(product.description || ''));

    var allowProductImage = modal.getAttribute('data-show-product-image') === 'true';
    var hasMedia = Boolean(allowProductImage && media && image && product.featuredImage);
    modal.classList.toggle('quick-order--has-media', hasMedia);
    if (hasMedia) {
      image.src = product.featuredImage;
      image.alt = product.featuredImageAlt || product.title || '';
      media.hidden = false;
    } else if (media && image) {
      media.hidden = true;
      image.removeAttribute('src');
      image.alt = '';
    }

    if (noteWrap) {
      noteWrap.hidden = !allowNote;
    }
    if (noteInput) {
      noteInput.disabled = !allowNote;
      noteInput.value = '';
    }
    if (quantityInput) {
      quantityInput.value = '1';
    }

    renderQuickOrderOptions(modal, product, selectedOptions);
    renderQuickOrderVariantSelect(modal, product, firstAvailable);
    renderQuickOrderSauces(modal, product);
    updateQuickOrderVariant(modal, firstAvailable);
    setFormMessage(form, '', '');
  }

  /**
   * Renders accessible option rows with prices and selected states.
   */
  function renderQuickOrderOptions(modal, product, selectedOptions) {
    var container = modal.querySelector('[data-quick-order-options]');
    if (!container) {
      return;
    }

    var optionNames = getProductOptionNames(product);
    if (!hasMeaningfulOptions(product, optionNames)) {
      container.innerHTML = '';
      container.hidden = true;
      return;
    }

    container.hidden = false;
    container.innerHTML = optionNames.map(function (optionName, index) {
      var values = getOptionValues(product, index);
      var buttons = values.map(function (value) {
        var isSelected = String(selectedOptions[index]) === String(value);
        var isAvailable = isOptionValueAvailable(product, index, value, selectedOptions);
        var price = getOptionValuePrice(product, index, value, selectedOptions);
        return [
          '<button class="quick-option-row' + (isSelected ? ' is-selected' : '') + '" type="button" role="radio" aria-checked="' + (isSelected ? 'true' : 'false') + '"',
          ' data-quick-option-button data-option-index="' + index + '" data-option-value="' + escapeAttribute(value) + '"' + (isAvailable ? '' : ' disabled') + '>',
            '<span class="quick-option-row__check" aria-hidden="true"><span></span></span>',
            '<span class="quick-option-row__label">' + escapeHTML(value) + '</span>',
            '<strong class="quick-option-row__price">' + (price == null ? '' : escapeHTML(formatMoney(price))) + '</strong>',
          '</button>'
        ].join('');
      }).join('');

      return '<fieldset class="quick-option-group"><legend>' + escapeHTML(optionName) + '</legend><div class="quick-option-list">' + buttons + '</div></fieldset>';
    }).join('');
  }

  /**
   * Renders a native variant select as a no-layout fallback.
   */
  function renderQuickOrderVariantSelect(modal, product, selectedVariant) {
    var wrap = modal.querySelector('[data-quick-order-variant-select-wrap]');
    var select = modal.querySelector('[data-quick-order-variant-select]');
    if (!wrap || !select) {
      return;
    }

    select.innerHTML = product.variants.map(function (variant) {
      return '<option value="' + escapeAttribute(variant.id) + '"' + (String(variant.id) === String(selectedVariant.id) ? ' selected' : '') + (variant.available ? '' : ' disabled') + '>' + escapeHTML(variant.title) + ' – ' + escapeHTML(formatMoney(variant.price)) + '</option>';
    }).join('');
    wrap.hidden = true;
  }

  /**
   * Renders the optional per-product sauce selector in the quick-order dialog.
   */
  function renderQuickOrderSauces(modal, product) {
    var wrap = modal ? modal.querySelector('[data-quick-order-sauces]') : null;
    if (!wrap) {
      return;
    }

    var sauceConfig = normalizeSauceConfig(product && product.sauceSelection);
    if (!sauceConfig) {
      wrap.innerHTML = '';
      wrap.hidden = true;
      return;
    }

    var choices = sauceConfig.options.map(function (option) {
      return [
        '<label class="sauce-choice">',
          '<input class="sauce-choice__input" type="checkbox" value="' + escapeAttribute(option) + '" data-sauce-option>',
          '<span class="sauce-choice__indicator" aria-hidden="true">✓</span>',
          '<span class="sauce-choice__label">' + escapeHTML(option) + '</span>',
        '</label>'
      ].join('');
    }).join('');

    wrap.innerHTML = [
      '<fieldset class="sauce-selector" data-sauce-selector data-sauce-max="' + sauceConfig.max + '">',
        '<legend class="sauce-selector__legend">',
          '<span>' + escapeHTML(sauceConfig.heading) + '</span>',
          '<span class="sauce-selector__counter" data-sauce-counter>0 / ' + sauceConfig.max + '</span>',
        '</legend>',
        '<p class="sauce-selector__help" data-sauce-help>Wähle bis zu ' + sauceConfig.max + ' Saucen aus.</p>',
        '<div class="sauce-selector__options">' + choices + '</div>',
        '<input type="hidden" name="properties[' + escapeAttribute(sauceConfig.propertyLabel) + ']" value="" data-sauce-property>',
        '<p class="sauce-selector__message" data-sauce-message role="status" aria-live="polite"></p>',
      '</fieldset>'
    ].join('');
    wrap.hidden = false;
    initSauceSelectors(wrap);
  }

  /**
   * Normalizes sauce configuration embedded in product JSON.
   */
  function normalizeSauceConfig(rawConfig) {
    if (!rawConfig || rawConfig.enabled === false || !Array.isArray(rawConfig.options)) {
      return null;
    }

    var seen = Object.create(null);
    var options = rawConfig.options.map(function (value) {
      return String(value == null ? '' : value).trim();
    }).filter(function (value) {
      if (!value || seen[value]) {
        return false;
      }
      seen[value] = true;
      return true;
    });

    if (!options.length) {
      return null;
    }

    var requestedMax = parseInt(rawConfig.max, 10);
    if (!Number.isFinite(requestedMax) || requestedMax < 1) {
      requestedMax = 3;
    }

    return {
      heading: String(rawConfig.heading || 'Saucen auswählen'),
      propertyLabel: String(rawConfig.propertyLabel || 'Saucen'),
      max: Math.min(requestedMax, options.length),
      options: options
    };
  }

  /**
   * Initializes all sauce selectors within a root node.
   */
  function initSauceSelectors(root) {
    var scope = root || document;
    var selectors = [];

    if (scope.matches && scope.matches('[data-sauce-selector]')) {
      selectors.push(scope);
    }
    if (scope.querySelectorAll) {
      selectors = selectors.concat(Array.prototype.slice.call(scope.querySelectorAll('[data-sauce-selector]')));
    }

    selectors.forEach(function (selector) {
      updateSauceSelector(selector, null, false);
    });
  }

  /**
   * Updates selected sauces, counter, disabled states, and line-item property.
   */
  function updateSauceSelector(selector, changedInput, announceLimit) {
    if (!selector) {
      return true;
    }

    var inputs = Array.prototype.slice.call(selector.querySelectorAll('[data-sauce-option]'));
    if (!inputs.length) {
      return true;
    }

    var configuredMax = parseInt(selector.getAttribute('data-sauce-max'), 10);
    if (!Number.isFinite(configuredMax) || configuredMax < 1) {
      configuredMax = 3;
    }
    var max = Math.min(configuredMax, inputs.length);
    selector.setAttribute('data-sauce-max', String(max));

    var selected = inputs.filter(function (input) { return input.checked; });
    var exceeded = selected.length > max;

    if (exceeded && changedInput && changedInput.checked) {
      changedInput.checked = false;
      selected = inputs.filter(function (input) { return input.checked; });
    }

    var atLimit = selected.length >= max;
    inputs.forEach(function (input) {
      var shouldDisable = atLimit && !input.checked;
      input.disabled = shouldDisable;
      var choice = input.closest('.sauce-choice');
      if (choice) {
        choice.classList.toggle('is-selected', input.checked);
        choice.classList.toggle('is-disabled', shouldDisable);
      }
    });

    var property = selector.querySelector('[data-sauce-property]');
    if (property) {
      property.value = selected.map(function (input) { return input.value; }).join(', ');
    }

    var counter = selector.querySelector('[data-sauce-counter]');
    setText(counter, selected.length + ' / ' + max);

    var help = selector.querySelector('[data-sauce-help]');
    setText(help, atLimit ? 'Maximale Auswahl erreicht.' : 'Wähle bis zu ' + max + ' Saucen aus.');

    selector.classList.toggle('is-at-limit', atLimit);
    selector.classList.toggle('has-selection', selected.length > 0);

    var message = selector.querySelector('[data-sauce-message]');
    if (message) {
      if (exceeded) {
        setText(message, strings.sauceLimit.replace('{count}', String(max)));
        selector.classList.add('has-error');
      } else {
        setText(message, '');
        selector.classList.remove('has-error');
      }
    }

    return !exceeded;
  }

  /**
   * Validates sauce selectors before a product is added to the cart.
   */
  function validateSauceSelectors(form, focusInvalid) {
    var selectors = form ? form.querySelectorAll('[data-sauce-selector]') : [];
    var valid = true;
    var firstInvalid = null;

    Array.prototype.forEach.call(selectors, function (selector) {
      var inputs = selector.querySelectorAll('[data-sauce-option]:checked');
      var max = parseInt(selector.getAttribute('data-sauce-max'), 10) || 3;
      updateSauceSelector(selector, null, false);
      if (inputs.length > max) {
        valid = false;
        firstInvalid = firstInvalid || selector;
      }
    });

    if (!valid && focusInvalid && firstInvalid) {
      var focusTarget = firstInvalid.querySelector('[data-sauce-option]:checked') || firstInvalid;
      if (focusTarget && typeof focusTarget.focus === 'function') {
        focusTarget.focus({ preventScroll: false });
      }
    }

    return valid;
  }

  /**
   * Updates selected option state and resolves the matching variant.
   */
  function selectQuickOption(button) {
    var modal = button.closest('[data-quick-order]');
    var state = modal ? modal._quickOrderState : null;
    if (!modal || !state || button.disabled) {
      return;
    }

    var optionIndex = parseInt(button.getAttribute('data-option-index'), 10);
    var value = button.getAttribute('data-option-value');
    if (!Number.isFinite(optionIndex)) {
      return;
    }

    state.selectedOptions[optionIndex] = value;
    var variant = findVariantByOptions(state.product, state.selectedOptions);
    renderQuickOrderOptions(modal, state.product, state.selectedOptions);
    updateQuickOrderVariant(modal, variant);

    var refreshedButton = modal.querySelector('[data-quick-option-button][data-option-index="' + optionIndex + '"][data-option-value="' + cssEscape(value) + '"]');
    if (refreshedButton) {
      refreshedButton.focus({ preventScroll: true });
    }
  }

  /**
   * Updates quick-order state from the native variant select.
   */
  function updateQuickOrderFromSelect(select) {
    var modal = select.closest('[data-quick-order]');
    var state = modal ? modal._quickOrderState : null;
    if (!modal || !state) {
      return;
    }

    var variant = findVariantById(state.product, select.value);
    if (variant) {
      state.selectedOptions = getVariantOptions(variant);
      renderQuickOrderOptions(modal, state.product, state.selectedOptions);
    }
    updateQuickOrderVariant(modal, variant);
  }

  /**
   * Updates quick-order variant, unit price, and availability.
   */
  function updateQuickOrderVariant(modal, variant) {
    var state = modal ? modal._quickOrderState : null;
    var form = modal ? modal.querySelector('[data-quick-order-form]') : null;
    var variantInput = modal ? modal.querySelector('[data-quick-order-variant-id]') : null;
    var addButton = form ? form.querySelector('[data-add-button]') : null;
    var select = modal ? modal.querySelector('[data-quick-order-variant-select]') : null;
    var available = Boolean(variant && variant.available);

    if (state) {
      state.selectedVariant = variant || null;
    }
    if (variantInput) {
      variantInput.value = variant ? variant.id : '';
    }
    modal.querySelectorAll('[data-quick-order-unit-price]').forEach(function (node) {
      node.textContent = variant ? formatMoney(variant.price || 0) : strings.unavailable;
    });
    if (select && variant) {
      select.value = String(variant.id);
    }
    if (addButton) {
      addButton.disabled = !available;
      addButton.classList.toggle('is-unavailable', !available);
    }

    updateQuickOrderTotal(modal);
  }

  /**
   * Updates quick-order totals for the selected quantity.
   */
  function updateQuickOrderTotal(modal) {
    var state = modal ? modal._quickOrderState : null;
    var form = modal ? modal.querySelector('[data-quick-order-form]') : null;
    var addButton = form ? form.querySelector('[data-add-button]') : null;
    var addLabel = addButton ? addButton.querySelector('[data-add-label]') : null;
    var addPrice = addButton ? addButton.querySelector('[data-add-price]') : null;
    var quantityInput = form ? form.querySelector('input[name="quantity"]') : null;
    var quantity = quantityInput ? parseInt(quantityInput.value, 10) : 1;

    if (!Number.isFinite(quantity) || quantity < 1) {
      quantity = 1;
    }

    if (!state || !state.selectedVariant || !state.selectedVariant.available) {
      setText(addLabel, strings.unavailable);
      setText(addPrice, '');
      if (addButton) {
        addButton.disabled = true;
      }
      return;
    }

    var total = Number(state.selectedVariant.price || 0) * quantity;
    setText(addLabel, strings.quickAdd || strings.add);
    setText(addPrice, formatMoney(total));
    if (addButton) {
      addButton.disabled = false;
    }
  }

  /**
   * Returns whether an option value can produce an available variant.
   */
  function isOptionValueAvailable(product, optionIndex, value, selectedOptions) {
    return product.variants.some(function (variant) {
      if (!variant.available) {
        return false;
      }
      var options = getVariantOptions(variant);
      if (String(options[optionIndex]) !== String(value)) {
        return false;
      }
      return selectedOptions.every(function (selectedValue, index) {
        return index === optionIndex || !selectedValue || String(options[index]) === String(selectedValue);
      });
    });
  }

  /**
   * Returns the lowest available price for an option value.
   */
  function getOptionValuePrice(product, optionIndex, value, selectedOptions) {
    var prices = product.variants.filter(function (variant) {
      if (!variant.available) {
        return false;
      }
      var options = getVariantOptions(variant);
      if (String(options[optionIndex]) !== String(value)) {
        return false;
      }
      return selectedOptions.every(function (selectedValue, index) {
        return index === optionIndex || !selectedValue || String(options[index]) === String(selectedValue);
      });
    }).map(function (variant) {
      return Number(variant.price || 0);
    });

    if (!prices.length) {
      prices = product.variants.filter(function (variant) {
        return variant.available && String(getVariantOptions(variant)[optionIndex]) === String(value);
      }).map(function (variant) {
        return Number(variant.price || 0);
      });
    }

    return prices.length ? Math.min.apply(Math, prices) : null;
  }

  /**
   * Closes the active quick-order dialog.
   */
  function closeQuickOrder(modal) {
    if (!modal || modal.hidden) {
      return;
    }

    modal.setAttribute('aria-hidden', 'true');
    modal.classList.remove('is-visible');
    modal.classList.add('is-closing');
    document.body.classList.remove('quick-order-open');

    window.setTimeout(function () {
      if (!document.body.classList.contains('quick-order-open')) {
        modal.hidden = true;
        modal.classList.remove('is-closing');
        restoreLastFocus();
      }
    }, prefersReducedMotion() ? 0 : 360);
  }

  /**
   * Returns the currently visible quick-order dialog.
   */
  function getActiveQuickOrder() {
    return document.querySelector('[data-quick-order]:not([hidden])');
  }

  /**
   * Returns product option names.
   */
  function getProductOptionNames(product) {
    return Array.isArray(product.options) && product.options.length ? product.options : ['Auswahl'];
  }

  /**
   * Determines whether option choices should be displayed.
   */
  function hasMeaningfulOptions(product, optionNames) {
    if (!product.variants || !product.variants.length) {
      return false;
    }
    if (product.variants.length > 1) {
      return true;
    }
    var onlyVariant = product.variants[0];
    var title = String(onlyVariant.title || '').toLowerCase();
    var firstOptionName = String(optionNames[0] || '').toLowerCase();
    return title !== 'default title' && firstOptionName !== 'title';
  }

  /**
   * Returns unique values for a product option index.
   */
  function getOptionValues(product, index) {
    var values = [];
    product.variants.forEach(function (variant) {
      var value = getVariantOptions(variant)[index];
      if (value && values.indexOf(value) === -1) {
        values.push(value);
      }
    });
    return values;
  }

  /**
   * Returns a variant's option values.
   */
  function getVariantOptions(variant) {
    if (Array.isArray(variant.options) && variant.options.length) {
      return variant.options.filter(function (value) { return value != null && String(value) !== ''; });
    }
    return [variant.option1, variant.option2, variant.option3].filter(function (value) {
      return value != null && String(value) !== '';
    });
  }

  /**
   * Finds a variant by selected option values.
   */
  function findVariantByOptions(product, options) {
    if (!product || !product.variants) {
      return null;
    }
    return product.variants.find(function (variant) {
      var variantOptions = getVariantOptions(variant);
      return options.every(function (value, index) {
        return String(variantOptions[index]) === String(value);
      });
    }) || null;
  }

  /**
   * Finds a variant by ID.
   */
  function findVariantById(product, id) {
    if (!product || !product.variants) {
      return null;
    }
    return product.variants.find(function (variant) {
      return String(variant.id) === String(id);
    }) || null;
  }

  /**
   * Adds a product form to the Shopify cart.
   */
  async function addToCart(form) {
    var button = form.querySelector('[data-add-button]');
    var modal = form.closest('[data-quick-order]');
    var originalText = button && !button.querySelector('[data-add-label]') ? button.textContent.trim() : strings.add;

    if (!validateSauceSelectors(form, true)) {
      setFormMessage(form, 'Bitte prüfe deine Saucenauswahl.', 'error');
      return;
    }

    try {
      setButtonLoading(button, true, strings.adding);
      setFormMessage(form, '', '');
      await postJSON(endpoints.add, buildAddPayload(form));
      showProductAddedToast(getAddedProductTitle(form, modal));
      var cart = await refreshCart();
      resetOptionalFields(form);
      resetQuantity(form);
      setFormMessage(form, strings.added, 'success');
      closeQuickOrder(modal);
      if (config.settings && config.settings.openCartDrawerAfterAdd) {
        openCartDrawer();
      }

      if (!cart || cart.item_count < 1) {
        throw new Error(strings.error);
      }
    } catch (error) {
      setFormMessage(form, error.message || strings.error, 'error');
    } finally {
      setButtonLoading(button, false, originalText);
      if (modal) {
        updateQuickOrderTotal(modal);
      }
    }
  }

  /**
   * Builds an Ajax Cart API payload from a product form.
   */
  function buildAddPayload(form) {
    var formData = new FormData(form);
    var item = { id: Number(formData.get('id')), quantity: Number(formData.get('quantity') || 1) };
    var properties = {};

    formData.forEach(function (value, key) {
      var match = key.match(/^properties\[(.+)\]$/);
      if (match && String(value).trim() !== '') {
        properties[match[1]] = String(value).trim();
      }
    });

    if (Object.keys(properties).length) {
      item.properties = properties;
    }
    return { items: [item] };
  }

  /**
   * Clears optional line-item properties after a successful add.
   */
  function resetOptionalFields(form) {
    form.querySelectorAll('[name^="properties["], [data-sauce-option]').forEach(function (field) {
      if (field.type === 'checkbox' || field.type === 'radio') {
        field.checked = false;
      } else {
        field.value = '';
      }
    });
    initSauceSelectors(form);
  }

  /**
   * Resets product-form quantity to one.
   */
  function resetQuantity(form) {
    form.querySelectorAll('input[name="quantity"]').forEach(function (field) {
      field.value = '1';
    });
  }


  /**
   * Updates a cart line and refreshes the cart drawer.
   */
  async function updateCartLine(key, quantity) {
    if (!key || !Number.isFinite(quantity)) {
      return;
    }

    try {
      await postJSON(endpoints.change, { id: key, quantity: Math.max(0, quantity) });
      await refreshCart();
    } catch (error) {
      if (window.console && window.console.warn) {
        window.console.warn(error);
      }
    }
  }

  /**
   * Updates a quantity input from plus and minus controls.
   */
  function updateFormQuantity(button) {
    var control = button.closest('[data-quantity-control], .quantity-control');
    var input = control ? control.querySelector('input[name="quantity"], input[type="number"]') : null;
    if (!input || input.readOnly) {
      return;
    }

    var current = parseInt(input.value, 10) || 1;
    var next = button.matches('[data-quantity-minus]') ? Math.max(1, current - 1) : current + 1;
    input.value = String(next);
    input.dispatchEvent(new Event('input', { bubbles: true }));
  }

  /**
   * Normalizes a quantity input to a positive integer.
   */
  function normalizeQuantityInput(input) {
    var quantity = parseInt(input.value, 10);
    input.value = String(Number.isFinite(quantity) && quantity > 0 ? quantity : 1);
  }

  /**
   * Updates a standard product form after variant selection.
   */
  function updateVariantState(select) {
    var form = select.closest('form');
    if (!form) {
      return;
    }

    var selectedOption = select.options[select.selectedIndex];
    var addButton = form.querySelector('[data-add-button]');
    var price = selectedOption ? selectedOption.getAttribute('data-price') : '';
    var available = selectedOption && !selectedOption.disabled;
    var card = select.closest('[data-product-card], .main-product');

    if (card && price) {
      card.querySelectorAll('[data-product-price]').forEach(function (node) {
        node.textContent = formatMoney(Number(price));
      });
    }
    if (addButton) {
      addButton.disabled = !available;
      setButtonLoading(addButton, false, available ? strings.add : strings.unavailable);
    }
  }

  /**
   * Fetches and renders the current cart.
   */
  async function refreshCart() {
    try {
      var cart = await fetchCart();
      renderCart(cart);
      return cart;
    } catch (error) {
      if (window.console && window.console.warn) {
        window.console.warn(error);
      }
      return null;
    }
  }

  /**
   * Fetches the current cart from Shopify's Ajax Cart API.
   */
  async function fetchCart() {
    var response = await fetch(endpoints.cart, { headers: { Accept: 'application/json' } });
    if (!response.ok) {
      throw new Error(strings.error);
    }
    return response.json();
  }

  /**
   * Sends a JSON POST request and validates the response.
   */
  async function postJSON(url, data) {
    var response = await fetch(url, {
      method: 'POST',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    });

    var payload = {};
    try {
      payload = await response.json();
    } catch (error) {
      payload = {};
    }

    if (!response.ok) {
      throw new Error(payload.description || payload.message || strings.error);
    }
    return payload;
  }

  /**
   * Keeps floating mobile controls clear of the optional cart bar.
   */
  function syncMobileCartBarState(itemCount) {
    var bar = document.querySelector('[data-mobile-cart-bar]');
    var isVisible = Boolean(bar && Number(itemCount || 0) > 0 && !bar.hidden);
    document.body.classList.toggle('has-mobile-cart-bar', isVisible);
  }

  /**
   * Renders cart counters, subtotal, and drawer line items.
   */
  function renderCart(cart) {
    if (!cart) {
      return;
    }

    document.querySelectorAll('[data-cart-count]').forEach(function (node) {
      node.textContent = String(cart.item_count || 0);
    });
    document.querySelectorAll('[data-cart-total]').forEach(function (node) {
      node.textContent = formatMoney(cart.total_price || 0);
    });
    document.querySelectorAll('[data-mobile-cart-bar]').forEach(function (node) {
      node.hidden = !cart.item_count;
    });
    syncMobileCartBarState(cart.item_count || 0);
    document.querySelectorAll('[data-checkout-button]').forEach(function (button) {
      button.disabled = !cart.item_count;
    });

    var drawer = getCartDrawer();
    var itemsContainer = drawer ? drawer.querySelector('[data-cart-items]') : null;
    if (!itemsContainer) {
      return;
    }

    if (!cart.items || !cart.items.length) {
      itemsContainer.innerHTML = '<div class="cart-drawer__empty"><p>' + escapeHTML(strings.emptyCart) + '</p><a class="button button--primary" href="' + escapeAttribute(rootUrl + '#speisekarte') + '">Speisekarte öffnen</a></div>';
      return;
    }
    itemsContainer.innerHTML = cart.items.map(renderCartItem).join('');
  }

  /**
   * Renders a cart drawer line item.
   */
  function renderCartItem(item) {
    var title = item.product_title || item.title || '';
    var variant = item.variant_title && item.variant_title !== 'Default Title' ? '<p>' + escapeHTML(item.variant_title) + '</p>' : '';
    var properties = renderProperties(item.properties);
    var key = escapeAttribute(item.key);
    var quantity = Number(item.quantity || 0);
    var showCartImages = Boolean(window.GastroFlow && window.GastroFlow.settings && window.GastroFlow.settings.showCartProductImages);
    var image = showCartImages && item.image ? '<a class="cart-drawer-line__media" href="' + escapeAttribute(item.url || '#') + '"><img src="' + escapeAttribute(item.image) + '&width=160" alt="" loading="lazy" width="80" height="80"></a>' : '';

    return [
      '<article class="cart-drawer-line' + (image ? ' cart-drawer-line--with-media' : '') + '">',
        image,
        '<div class="cart-drawer-line__content">',
          '<h3><a href="' + escapeAttribute(item.url || '#') + '">' + escapeHTML(title) + '</a></h3>',
          variant,
          properties,
          '<small>' + quantity + ' × ' + formatMoney(item.final_price || item.price || 0) + '</small>',
        '</div>',
        '<strong class="cart-drawer-line__price">' + formatMoney(item.final_line_price || item.line_price || 0) + '</strong>',
        '<div class="cart-drawer-line__controls">',
          '<div class="quantity-control" aria-label="Menge ändern">',
            '<button type="button" aria-label="Anzahl reduzieren" data-line-change data-key="' + key + '" data-quantity="' + Math.max(0, quantity - 1) + '">−</button>',
            '<input type="number" value="' + quantity + '" readonly aria-label="Anzahl">',
            '<button type="button" aria-label="Anzahl erhöhen" data-line-change data-key="' + key + '" data-quantity="' + (quantity + 1) + '">+</button>',
          '</div>',
          '<button class="cart-drawer-line__remove" type="button" data-line-remove data-key="' + key + '">' + escapeHTML(strings.remove) + '</button>',
        '</div>',
      '</article>'
    ].join('');
  }

  /**
   * Renders visible non-private line-item properties.
   */
  function renderProperties(properties) {
    if (!properties || typeof properties !== 'object') {
      return '';
    }
    var output = Object.keys(properties).filter(function (key) {
      return key.charAt(0) !== '_' && String(properties[key] || '').trim() !== '';
    }).map(function (key) {
      var displayKey = String(key).replace(/Soßen/g, 'Saucen').replace(/Soße/g, 'Sauce');
      return '<div><dt>' + escapeHTML(displayKey) + '</dt><dd>' + escapeHTML(String(properties[key])) + '</dd></div>';
    }).join('');
    return output ? '<dl class="line-properties">' + output + '</dl>' : '';
  }

  /**
   * Opens the cart drawer and moves focus inside it.
   */
  function openCartDrawer() {
    var drawer = getCartDrawer();
    if (!drawer) {
      return;
    }

    drawer.hidden = false;
    drawer.setAttribute('aria-hidden', 'false');
    window.requestAnimationFrame(function () {
      document.body.classList.add('cart-drawer-open');
      var closeButton = drawer.querySelector('[data-cart-close]');
      if (closeButton) {
        closeButton.focus({ preventScroll: true });
      }
    });
  }

  /**
   * Closes the cart drawer.
   */
  function closeCartDrawer() {
    var drawer = getCartDrawer();
    if (!drawer || drawer.hidden) {
      return;
    }

    document.body.classList.remove('cart-drawer-open');
    drawer.setAttribute('aria-hidden', 'true');
    window.setTimeout(function () {
      if (!document.body.classList.contains('cart-drawer-open')) {
        drawer.hidden = true;
        restoreLastFocus();
      }
    }, prefersReducedMotion() ? 0 : 220);
  }

  /**
   * Returns the cart drawer element.
   */
  function getCartDrawer() {
    return document.querySelector('[data-cart-drawer]');
  }

  /**
   * Keeps keyboard focus inside an overlay.
   */
  function trapFocus(event, root) {
    if (!root) {
      return;
    }
    var focusable = root.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), textarea:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])');
    if (!focusable.length) {
      return;
    }
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  /**
   * Updates a form status message.
   */
  function setFormMessage(form, message, state) {
    if (!form) {
      return;
    }
    var messageNode = form.querySelector('[data-form-message]');
    if (!messageNode) {
      return;
    }
    messageNode.textContent = message || '';
    if (state) {
      messageNode.setAttribute('data-state', state);
    } else {
      messageNode.removeAttribute('data-state');
    }
  }

  /**
   * Toggles loading state without destroying structured button content.
   */
  function setButtonLoading(button, isLoading, label) {
    if (!button) {
      return;
    }
    var labelNode = button.querySelector('[data-add-label]');
    button.disabled = Boolean(isLoading);
    button.setAttribute('aria-busy', isLoading ? 'true' : 'false');
    button.classList.toggle('is-loading', Boolean(isLoading));
    if (labelNode) {
      labelNode.textContent = label || strings.quickAdd || strings.add;
    } else if (label) {
      button.textContent = label;
    }
  }

  /**
   * Sets safe text content for a node.
   */
  function setText(node, value) {
    if (node) {
      node.textContent = value || '';
    }
  }

  /**
   * Strips HTML tags from a string.
   */
  function stripHTML(value) {
    var container = document.createElement('div');
    container.innerHTML = String(value || '');
    return (container.textContent || container.innerText || '').trim();
  }

  /**
   * Handles the configured discount-code action.
   */
  async function copyDiscountCode(button) {
    var code = button ? button.getAttribute('data-copy-code') : '';
    if (!code) {
      return;
    }

    var applyUrl = button.getAttribute('data-discount-apply-url');
    var action = button.getAttribute('data-discount-action') || (applyUrl ? 'apply' : 'copy');

    if (action === 'apply' && applyUrl) {
      showCopyFeedback(button, code, 'apply');
      button.classList.add('is-applying');
      button.disabled = true;
      window.setTimeout(function () {
        window.location.assign(applyUrl);
      }, prefersReducedMotion() ? 50 : 450);
      return;
    }

    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(code);
      } else {
        var temporaryInput = document.createElement('textarea');
        temporaryInput.value = code;
        temporaryInput.setAttribute('readonly', '');
        temporaryInput.style.position = 'fixed';
        temporaryInput.style.opacity = '0';
        document.body.appendChild(temporaryInput);
        temporaryInput.select();
        document.execCommand('copy');
        temporaryInput.remove();
      }

      showCopyFeedback(button, code, 'copy');
    } catch (error) {
      showCopyToast('Code: ' + code);
    }
  }

  /**
   * Toggles inline feedback and the global toast for discount buttons.
   */
  function showCopyFeedback(button, code, action) {
    var defaultContent = button.querySelector('[data-copy-default]');
    var successContent = button.querySelector('[data-copy-success]');
    var originalLabel = button.getAttribute('aria-label') || '';
    var isApplyAction = action === 'apply';
    var feedbackText = isApplyAction ? 'Rabattcode ' + code + ' wird angewendet' : 'Rabattcode ' + code + ' kopiert';

    button.classList.add(isApplyAction ? 'is-applying' : 'is-copied');
    button.setAttribute('aria-label', feedbackText);

    if (defaultContent) {
      defaultContent.hidden = true;
    }
    if (successContent) {
      successContent.hidden = false;
    }

    showCopyToast(feedbackText);

    if (isApplyAction) {
      return;
    }

    window.setTimeout(function () {
      button.classList.remove('is-copied');
      if (originalLabel) {
        button.setAttribute('aria-label', originalLabel);
      }
      if (defaultContent) {
        defaultContent.hidden = false;
      }
      if (successContent) {
        successContent.hidden = true;
      }
    }, 1900);
  }

  /**
   * Displays a non-blocking copy confirmation toast.
   */

  function showCopyToast(message) {
    var toast = document.querySelector('[data-copy-toast]');
    if (!toast) {
      return;
    }
    var text = toast.querySelector('[data-copy-toast-text]');
    setText(text, message || strings.copied);
    toast.hidden = false;
    window.requestAnimationFrame(function () {
      toast.classList.add('is-visible');
    });
    window.clearTimeout(copyToastTimer);
    copyToastTimer = window.setTimeout(function () {
      toast.classList.remove('is-visible');
      window.setTimeout(function () { toast.hidden = true; }, prefersReducedMotion() ? 0 : 220);
    }, 2200);
  }

  /**
   * Returns whether reduced motion is requested.
   */
  function prefersReducedMotion() {
    return document.body.classList.contains('reduce-motion') ||
      (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }


  /**
   * Returns a concise title for the product that was just added.
   */
  function getAddedProductTitle(form, modal) {
    if (modal && modal._quickOrderState && modal._quickOrderState.product && modal._quickOrderState.product.title) {
      return modal._quickOrderState.product.title;
    }

    var productRoot = form ? form.closest('.main-product, [data-product-card]') : null;
    var title = productRoot ? productRoot.querySelector('h1, .product-card__title') : null;
    return title ? title.textContent.trim() : '';
  }

  /**
   * Shows a small non-blocking confirmation after a product was added.
   */
  function showProductAddedToast(productTitle) {
    var toast = document.querySelector('[data-product-added-toast]');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'product-added-toast';
      toast.setAttribute('data-product-added-toast', '');
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      toast.hidden = true;
      toast.innerHTML = '<span class="product-added-toast__icon" aria-hidden="true">✓</span><span class="product-added-toast__copy"><strong data-product-added-toast-heading></strong><small data-product-added-toast-title></small></span>';
      document.body.appendChild(toast);
    }

    var heading = toast.querySelector('[data-product-added-toast-heading]');
    var title = toast.querySelector('[data-product-added-toast-title]');
    setText(heading, strings.productAdded || 'Produkt hinzugefügt');
    setText(title, productTitle || '');
    if (title) {
      title.hidden = !productTitle;
    }

    toast.hidden = false;
    window.requestAnimationFrame(function () {
      toast.classList.add('is-visible');
    });

    window.clearTimeout(productToastTimer);
    productToastTimer = window.setTimeout(function () {
      toast.classList.remove('is-visible');
      window.setTimeout(function () {
        if (!toast.classList.contains('is-visible')) {
          toast.hidden = true;
        }
      }, prefersReducedMotion() ? 0 : 220);
    }, 2600);
  }

  /**
   * Formats Shopify cent values with the shop money format.
   */
  function formatMoney(cents) {
    var numericCents = Number(cents || 0);
    var amount = numericCents / 100;
    var format = String(config.moneyFormat || '{{amount_with_comma_separator}} €').replace(/<[^>]*>/g, '');
    var amountDot = amount.toFixed(2);
    var amountComma = amountDot.replace('.', ',');
    var amountNoDecimals = String(Math.round(amount));

    return format
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, amountNoDecimals)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amountNoDecimals)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amountComma)
      .replace(/\{\{\s*amount\s*\}\}/g, amountDot);
  }

  /**
   * Escapes text for safe HTML insertion.
   */
  function escapeHTML(value) {
    return String(value == null ? '' : value).replace(/[&<>'"]/g, function (character) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        "'": '&#39;',
        '"': '&quot;'
      }[character];
    });
  }

  /**
   * Escapes text for safe HTML attributes.
   */
  function escapeAttribute(value) {
    return escapeHTML(value);
  }

  /**
   * Escapes a value for an attribute-selector string.
   */
  function cssEscape(value) {
    if (window.CSS && typeof window.CSS.escape === 'function') {
      return window.CSS.escape(String(value));
    }
    return String(value).replace(/["\\]/g, '\\$&');
  }
}());
